module.exports = __webpack_public_path__ + "media/src/assets/images/hydrus-b5b8310c4cb5ff30245b625e74e5c722.svg";